<ng-container *transloco="let t; read: 'permissions'">
  <div class="permission-editor">

    <p class="base-rights-hint">{{ t('baseRightsHint') }}</p>

    <h4 class="section-title">{{ t('permissionGroups') }}</h4>

    <div class="category-list">
      <div class="category" *ngFor="let category of categories">
        <span class="category-title">{{ t('category.' + category.name) }}</span>

        <label class="group-row" *ngFor="let group of category.groups">
          <input
            type="checkbox"
            kendoCheckBox
            [checked]="isGroupSelected(group.key)"
            (change)="toggleGroup(group.key, $any($event.target).checked)"
          />
          <span class="group-text">
            <span class="group-name">
              {{ group.displayName }}
            </span>
            <span class="group-description">{{ group.description }}</span>
          </span>
        </label>
      </div>
    </div>

    <div class="exceptions" *ngIf="exceptionRows.length">
      <h4 class="section-title">{{ t('exceptions') }}</h4>
      <p class="exceptions-hint">{{ t('exceptionsHint') }}</p>
      <ul class="exception-list">
        <li *ngFor="let row of exceptionRows">{{ row.displayName }}</li>
      </ul>
    </div>

    <div class="details">
      <button kendoButton fillMode="flat" (click)="toggleDetails()">
        {{ showDetails ? t('hideDetails') : t('showDetails') }}
        ({{ grantedCount }})
      </button>

      <div class="detail-list" *ngIf="showDetails">
        <p class="detail-hint">{{ t('detailHint') }}</p>

        <label class="permission-row" *ngFor="let row of permissionRows">
          <input
            type="checkbox"
            kendoCheckBox
            [checked]="row.granted"
            (change)="togglePermission(row, $any($event.target).checked)"
          />
          <span class="permission-name">{{ row.displayName }}</span>
          <span class="origin origin-{{ row.origin }}">{{ t('origin.' + row.origin) }}</span>
        </label>
      </div>
    </div>

    <div class="save-action">
      <span class="save-state" *ngIf="saved">{{ t('savedNotice') }}</span>
      <button kendoButton themeColor="primary" [disabled]="saving" (click)="save()">
        {{ saving ? t('saving') : t('save') }}
      </button>
    </div>

  </div>
</ng-container>
